<template>

<v-card :disabled="disable" :class="{ pasifCard: disable }"
  elevation="3"
>
 <v-card-text >
    <div v-if="disable"  style="background: white;"><span style="color: red;">Bu öğe pasif olduğundan başvuru ekranında görüntülenmeyecektir. </span></div>
                   <p class="ma-0">
            <strong style="color: black;" v-html="label"> </strong> <strong v-if="required" style="color: red;margin:0px 5px;">*</strong> 
         </p> 
  <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px"
        min-width="290px">

        <template v-slot:activator="{ on, attrs }">

            <v-text-field v-model="formattedDate"  :prepend-icon="icon" readonly v-bind="attrs" v-on="on"
                :rules="listRules" :required="required" :hint="hint" :placeholder="placeholder" clearable  persistent-hint
                @click:clear="clearDate">
              <!-- <template v-slot:label>
              <p> 
                    <strong v-if="required" style="color: red;margin:0px 5px;">*</strong> <strong v-html="label"> </strong>  
                  </p>
        </template> -->
            </v-text-field>
        </template>

        <v-date-picker v-model="selectedDate" :min="min" :max="max" :locale="locale" scrollable :active-picker.sync="activePicker"
            @input="onDateSelected"></v-date-picker>
    </v-menu>
</v-card-text>
</v-card>



</template>

<script>
import { dateSF } from '@/plugins/FieldDataFormat.js'
import { rules } from '@/plugins/custom.js'
export default {
    name: 'DatePickerField',
    props: {
        ayar: {
            // default: '{"title":"","description":""}',
            default() {
                return dateSF;
            },
            type: Object
        },
        value: {
            type: String,
            default: null
        },
        // min: {
        //     type: String,
        //     default: () => ''
        // },
        // max: {
        //     type: String,
        //     default: () => {
        //         const d = new Date();
        //         d.setMonth(d.getMonth() + 3);
        //         return d.toISOString().substr(0, 10);
        //     }
        // },

        icon: {
            type: String,
            default: 'mdi-calendar'
        },

        locale: {
            type: String,
            default: 'tr'
        },



    },
    data() {
        return {
            menu: false,
            clearable: true,
            selectedDate: this.value,
            label: "",
            required: false,
            rules: [],
            placeholder: "Yanıtınız",
            hint: "",
            activePicker:null,
            disable:false,
            max:null,
            min:null,
        };
    },

    computed: {
          listRules() {
            console.log("listRules:",this.rules);
return this.rules.map(m=>rules[m]);
    
        },
        formattedDate: {
            get() {
                return this.selectedDate ? this.formatDate(this.selectedDate) : '';
            },
            set(val) {
                // Kullanıcı manuel silerse (örn: clearable), tarih temizlenmiş olur
                if (!val) {
                    this.selectedDate = null;
                    this.$emit('input', null);
                }
            }
        }
    },
    watch: {
        value(val) {
            this.selectedDate = val;
        },
         ayar: {
            immediate: true,
            handler(newVal, oldVal) {

              this.dataBind(newVal);
           
            },
            deep: true
        }

    },
    created() {
        this.dataBind(this.ayar);
    },
    methods: {
        clearDate() {
            this.selectedDate = null;
            this.$emit('input', null);
        },
        dataBind(json) {


this.disable=json.disable;
            this.description = json.description;
            this.rules = json?.rules ?? [];
            this.hint = json?.hint ?? "";
            this.label = json.label;
            this.placeholder = json.placeholder;
this.min=json.min;
this.max=json.max;
            this.required = json?.required ?? false;
        },
        onDateSelected(date) {
            this.menu = false;
            this.selectedDate = date;
            this.$emit('input', date);
        },
        formatDate(date) {
            console.log("formatDate", date);
            // if (date == null) {
            //     return '';
            // }
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        }
    }
};
</script>
<style scoped>
.pasifCard{
  background-color: gray !important;
}

</style>